var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useEffect, useCallback } from 'react';
import useStepper from './useStepper';
import { Route, useLocation, useHistory } from './WizardRouter';
var Step = function (_a) {
    var id = _a.id, children = _a.children;
    return (_jsx(Route, __assign({ path: id }, { children: children }), void 0));
};
/**
 * Connect your component to a Wizard as a step.
 * @param {Object} stepConfig useStep
 * @param {(string|number)} stepConfig.id Your steps unique ID, used for navigation.
 * @param {function} stepConfig.onStepChange Triggers when navigating away from the step.
 * @param {boolean} stepConfig.showStepper Show or hide the stepper component.
 * @returns {Step} Step object.
 */
var useStep = function (_a) {
    var id = _a.id, _b = _a.onStepChange, onStepChange = _b === void 0 ? function () { } : _b, _c = _a.showStepper, showStepper = _c === void 0 ? true : _c;
    var activeStep = useLocation().pathname;
    var _d = useHistory(), goBack = _d.goBack, goForward = _d.goForward, steps = _d.entries, canGo = _d.canGo, go = _d.go;
    var _e = useStepper(), setShowStepper = _e.setShowStepper, setStepProps = _e.setStepProps;
    var isActiveStep = activeStep === id;
    var getStepIndex = function (stepId) {
        return steps.map(function (e) { return e.pathname; }).indexOf("" + stepId);
    };
    var activeStepIndex = getStepIndex(activeStep);
    var canGoBack = canGo(-1);
    var canGoForward = canGo(1);
    var canGoTo = function (stepId) {
        var idIndex = getStepIndex(stepId);
        return canGo(idIndex);
    };
    var goTo = function (stepId) {
        var idIndex = getStepIndex(stepId);
        if (canGoTo(stepId)) {
            go(idIndex);
        }
    };
    useEffect(function () {
        onStepChange(activeStep === id);
    }, [activeStep, id, onStepChange]);
    useEffect(function () {
        if (isActiveStep) {
            setShowStepper(showStepper);
        }
    }, [setShowStepper, showStepper, isActiveStep]);
    var setStepperProps = useCallback(function (newState) {
        setStepProps(function (state) {
            var _a;
            return __assign(__assign({}, state), (_a = {}, _a[id] = __assign(__assign({}, state[id]), newState), _a));
        });
    }, [id, setStepProps]);
    var MemoizedStep = useCallback(function (props) { return _jsx(Step, __assign({ id: id }, props), void 0); }, [id]);
    return {
        isActiveStep: isActiveStep,
        setStepperProps: setStepperProps,
        stepIndex: getStepIndex(id),
        steps: steps,
        activeStep: activeStep,
        activeStepIndex: activeStepIndex,
        go: go,
        goBack: goBack,
        canGoBack: canGoBack,
        goForward: goForward,
        canGoForward: canGoForward,
        goTo: goTo,
        canGoTo: canGoTo,
        Step: MemoizedStep
    };
};
export default useStep;
